"use client";

import type { FC } from "react";
import { cn } from "utils";
import { SIGN_IN_PAGE_COPY } from "../signInPageCopy";

interface SignInHeadlineProps {
  prefix?: string;
  accent?: string;
  subtitle?: string;
  className?: string;
}

/** UI2 Sign in title block — prefix + accent span + subtitle (D16/D19). */
export const SignInHeadline: FC<SignInHeadlineProps> = ({
  prefix = SIGN_IN_PAGE_COPY.headlinePrefix,
  accent = SIGN_IN_PAGE_COPY.headlineAccent,
  subtitle = SIGN_IN_PAGE_COPY.subtitle,
  className,
}) => (
  <div
    className={cn("flex w-full flex-col gap-3", className)}
    data-testid="sign-in-headline"
  >
    <h1
      aria-label="Sign in headline"
      data-openreplay-label="Sign in headline"
      data-testid="sign-in-headline-title"
      className="headline_regular_m text-content_primary"
    >
      {prefix}
      <span className="text-content_accent4_primary">{accent}</span>
    </h1>
    <p
      className="body_medium_m text-content_secondary"
      data-testid="sign-in-headline-subtitle"
    >
      {subtitle}
    </p>
  </div>
);
